import styled from "styled-components";

export const MetadataItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-size: 12px;

  strong {
    color: ${({ theme }) => theme.text};
    font-weight: 600;
  }

  span {
    color: ${({ theme }) => theme.textSecondary };
  }
`;

export const BadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

interface BadgeProps {
  type?: "service" | "worker" | "ui";
}

const typeColors = {
  service: "#3b82f6",
  worker: "#8b5cf6",
  ui: "#ec4899",
};

export const LatestBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  color: #3fb950;
  border: 1px solid #3fb95044;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const TypeBadge = styled.span<BadgeProps>`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  padding: 6px 12px;
  background: ${({ type }) => (type ? typeColors[type] : "#3b82f6")}11;
  color: ${({ type }) => (type ? typeColors[type] : "#3b82f6")};
  border: 1px solid ${({ type }) => (type ? typeColors[type] : "#3b82f6")}44;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const ReviewInput = styled.textarea`
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.875rem;
  font-family: 'Roboto';
  min-height: 100px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #2E933C;
    box-shadow: 0 0 0 2px rgba(46, 147, 60, 0.1);
  }
`;
